import { PropTypes } from 'prop-types';
import React from 'react';
import { Highlight, Snippet } from 'react-instantsearch-dom';

import ArrowNormal from '../../assets/svg/arrow-normal.svg';
import { getArticleUrl, getFormattedDate } from '../../utils';
import Link from '../Link';

const LibrarySearchHit = ({ hit }) => {
  const date = getFormattedDate(hit?.publishedDate);

  const url = getArticleUrl({ slug: hit?.slug, type: hit?.internal?.type });

  return (
    <div className="pt-16 pb-16 border-b border-smoke border-opacity-30 library-container">
      <div className="order-2 sm:order-1 sm:col-start-1 sm:col-end-6 lg:col-start-1 lg:col-end-5">
        <p className="stink-footnote text-slate mb-6 lg:mb-0">{date}</p>
        <div className="flex flex-wrap gap-2 mt-2">
          {hit?.tags?.map((item) => {
            const { id, name, slug, type } = item;
            return (
              <Link
                key={id}
                ariaLabel={`Go to topic ${name}`}
                className="p-2 overflow-hidden whitespace-nowrap overflow-ellipsis stink-eyebrow uppercase text-creme bg-[#DFC4AC] bg-opacity-40 w-[fit-content] text-hover"
                to={`/${type}/${slug}`}
              >
                {name}
              </Link>
            );
          })}
        </div>
      </div>
      <div className="order-1 sm:order-2 sm:col-start-6 sm:col-end-12 lg:col-start-8 lg:col-end-[18]">
        <Link to={url}>
          <h4 className="stink-h4 text-smoke text-hover">
            <Highlight attribute="title" hit={hit} tagName="mark" />
          </h4>
          <p className="hidden lg:block mt-4 text-smoke stink-body-2">
            <Snippet attribute="body" hit={hit} tagName="mark" />
          </p>
        </Link>
      </div>
      <div className="hidden lg:block lg:col-span-3 order-3">
        <Link
          ariaLabel={`Go to ${hit.title}`}
          className="flex items-start justify-end h-full"
          to={url}
        >
          <ArrowNormal className="w-5 fill-current text-whitish" />
        </Link>
      </div>
    </div>
  );
};

LibrarySearchHit.propTypes = {
  hit: PropTypes.object,
};

export default LibrarySearchHit;
